"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = mapSubjectSelfAsGift;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _invariant = _interopRequireDefault(require("invariant"));

var _get = _interopRequireDefault(require("lodash/fp/get"));

var _cond = _interopRequireDefault(require("lodash/fp/cond"));

var _createSubjectIndirectSubjects = _interopRequireDefault(require("../createSubjectIndirectSubjects"));

// setting
// [row[COL_X_AMOUNT], row[COL_Y_AMOUNT], 0.01, 'fixedPriceSubject']
function mapSubjectSelfAsGift(_x, _x2, _x3, _x4, _x5, _x6, _x7) {
  return _mapSubjectSelfAsGift.apply(this, arguments);
}

function _mapSubjectSelfAsGift() {
  _mapSubjectSelfAsGift = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(ctx, rule, subject, settings, perNum, giftPriceOption, subjectPrice) {
    var product, quantity, _ref, _ref2, modulo, per, giftPrice, fixedPriceSetting, productModifier, fixedPrice, m, cnt, discountedProduct, result;

    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            (0, _invariant.default)(typeof settings === 'string' || typeof settings === 'number', 'mapSubjectSelfAsGift requires settings to be type of `string` or `number` for modulo.');
            product = subject.product, quantity = subject.quantity; // load settings from product price extensions

            _ref = typeof settings === 'string' ? (0, _get.default)(settings, subject) : function () {
              if (subjectPrice === undefined) {
                subjectPrice = giftPriceOption;
                giftPriceOption = perNum;
                perNum = 1;
              }

              return [settings, perNum, giftPriceOption, subjectPrice];
            }(), _ref2 = (0, _slicedToArray2.default)(_ref, 5), modulo = _ref2[0], per = _ref2[1], giftPrice = _ref2[2], fixedPriceSetting = _ref2[3], productModifier = _ref2[4];
            fixedPrice = (0, _cond.default)([[function (x) {
              return typeof x === 'boolean';
            }, function (x) {
              return x;
            }], [function (x) {
              return x === 'fixedSubjectPrice';
            }, function () {
              return true;
            }], [function () {
              return true;
            }, function () {
              return false;
            }]])(fixedPriceSetting);
            m = Math.floor(quantity / modulo);
            cnt = m * per;

            if (!(cnt <= 0)) {
              _context.next = 8;
              break;
            }

            return _context.abrupt("return", null);

          case 8:
            discountedProduct = productModifier ? (0, _extends2.default)({}, product, productModifier) : product;
            _context.next = 11;
            return (0, _createSubjectIndirectSubjects.default)(ctx, rule, discountedProduct, giftPrice, cnt, fixedPrice);

          case 11:
            result = _context.sent;
            return _context.abrupt("return", (0, _extends2.default)({}, result));

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _mapSubjectSelfAsGift.apply(this, arguments);
}